import { render, staticRenderFns } from "./DrawerEmpresas.vue?vue&type=template&id=801e4a60&scoped=true&"
import script from "./DrawerEmpresas.vue?vue&type=script&lang=js&"
export * from "./DrawerEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./DrawerEmpresas.vue?vue&type=style&index=0&id=801e4a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801e4a60",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QInput,QList,QItem,QItemSection,QItemLabel});qInstall(component, 'directives', {Ripple});
